import { render, staticRenderFns } from "./program-list.vue?vue&type=template&id=0f3642c9"
import script from "./program-list.vue?vue&type=script&lang=js"
export * from "./program-list.vue?vue&type=script&lang=js"
import style0 from "./program-list.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports